import { DateTime } from 'luxon';

export function utcNow(): DateTime {
  return DateTime.now().toUTC()
}

export function dateDiff(fromDate: string, toDate: string): number {
  const start = DateTime.fromISO(fromDate);
  const end = DateTime.fromISO(toDate);
  const diff = end.diff(start, ["hours", "minutes", "seconds"])
  return parseInt(diff.toFormat("s"))
}

export function getHumanDateDiff(fromDate: string, toDate?: string):string {
    const start = DateTime.fromISO(fromDate);
    let end = DateTime.now()
    if (toDate) {
      end = DateTime.fromISO(toDate);
    }

    const diff = end.diff(start, ["hours", "minutes", "seconds"])

    const rtn = []
    if (diff.hours) {
      rtn.push(diff.hours + ' hour' + (diff.hours > 1 ? 's' : ''))
    }
    if (diff.minutes) {
      rtn.push(diff.minutes + ' minute' + (diff.minutes > 1 ? 's' : ''))
    }
    if (diff.seconds) {
      const val = Math.ceil(diff.seconds)
      rtn.push(val + ' second' + (val > 1 ? 's' : ''))
    }
    if (rtn.length < 1) {
      return '< 1 second';
    }
    return rtn.join(', ')

}

export function getHumanDate(isodate: string): string {
    return DateTime.fromISO(isodate).toFormat('yyyy/LL/dd HH:mm:ss ZZZZ');
}

export function getHumanDateOffset(dateString: string):string|null {
  const refDate = DateTime.fromISO(dateString);
  return refDate.toRelative();
}